export default __webpack_public_path__ + "static/media/Warning.aabf6b67.svg";